import * as React from "react";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";

import { userRemoveQuestion } from "../../../actions";
import { RemoveQuestionWrapperProps } from "../../../model";

interface Props {
    removable: RemoveQuestionWrapperProps;
}

export const RemoveQuestionButton: React.FunctionComponent<Props> = (props: Props) => {

    const { questionnaireKey, sectionId, questionId } = props.removable;

    const dispatch = useDispatch();
    const onRemoveQuestion = () => {
        dispatch(userRemoveQuestion({ questionnaireKey, sectionId, id: questionId }));
    };

    return (
        <Button
            negative
            icon="delete"
            size="mini"
            onClick={onRemoveQuestion}
        />
    );
};
